import React from "react";
import { Check, Minus } from "lucide-react";
import { differentiation } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";

export const Differentiation = () => (
  <section data-testid="differentiation-section" className="bg-offwhite py-24 lg:py-32 border-t border-hair">
    <div className="container-page">
      <SectionHeading eyebrow={differentiation.eyebrow}>{differentiation.heading}</SectionHeading>
      <Reveal delay={0.1}>
        <p className="mt-6 text-slate-ink text-base lg:text-lg leading-relaxed max-w-2xl">
          {differentiation.intro}
        </p>
      </Reveal>

      {/* Comparison table */}
      <Reveal delay={0.15} className="mt-14 overflow-x-auto">
        <table className="w-full min-w-[720px] border-collapse" data-testid="comparison-table">
          <thead>
            <tr>
              <th className="w-[24%]" />
              {differentiation.columns.map((c, i) => (
                <th
                  key={c}
                  className={`text-left p-4 lg:p-5 align-bottom border-b-2 ${
                    i === 0 ? "border-teal" : "border-hair"
                  }`}
                >
                  <span
                    className={`font-display font-bold text-sm lg:text-base tracking-tight ${
                      i === 0 ? "text-navy" : "text-slate-ink"
                    }`}
                  >
                    {c}
                  </span>
                  {i === 0 && (
                    <span className="block mt-1 text-[10px] uppercase tracking-[0.2em] text-teal font-semibold">
                      This program
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {differentiation.rows.map((r) => (
              <tr key={r.criterion} className="border-b border-hair">
                <td className="p-4 lg:p-5 font-display font-semibold text-navy text-sm align-top">
                  {r.criterion}
                </td>
                <td className="p-4 lg:p-5 bg-white text-sm text-navy align-top border-x border-hair">
                  <span className="flex gap-2">
                    <Check className="h-4 w-4 text-teal shrink-0 mt-0.5" />
                    {r.otp}
                  </span>
                </td>
                <td className="p-4 lg:p-5 text-sm text-slate-ink align-top">
                  <span className="flex gap-2">
                    <Minus className="h-4 w-4 text-slate-ink/50 shrink-0 mt-0.5" />
                    {r.generic}
                  </span>
                </td>
                <td className="p-4 lg:p-5 text-sm text-slate-ink align-top">
                  <span className="flex gap-2">
                    <Minus className="h-4 w-4 text-slate-ink/50 shrink-0 mt-0.5" />
                    {r.diploma}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>

      {/* Five pillars */}
      <div className="mt-16 grid md:grid-cols-5 border-t border-l border-hair">
        {differentiation.pillars.map((p, i) => (
          <Reveal
            key={p.title}
            delay={i * 0.06}
            className="border-r border-b border-hair p-6"
          >
            <span className="font-display font-bold text-xs text-gold">0{i + 1}</span>
            <h3 className="mt-3 font-display font-bold text-navy text-[15px] tracking-tight leading-snug">
              {p.title}
            </h3>
            <p className="mt-2 text-slate-ink text-[13px] leading-relaxed">{p.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
